import React from 'react';

import NaviLogo from '@/Components/SVG/NaviLogo';

const GuestHeader: React.FC = () => {
    return (
        <>
            <header className="global-header">
                <div className="global-header__inner">
                    <div className="global-header__logo">
                        <NaviLogo />
                    </div>
                </div>
            </header>
        </>
    );
};

export default React.memo(GuestHeader);
